module.exports = __webpack_public_path__ + "img/profile-1.19704aca.png";